<template>
  <div
    v-if="shouldShow"
    :class="css"
    class="km-empty"
  >
    <div class="km-empty__img">
      <slot name="image">
        <img
          v-if="image"
          :src="image"
          :alt="description"
        >
        <img
          :class="imgCss"
          :src="imageDefault"
        >
      </slot>
    </div>
    <div
      v-if="hasTitle"
      class="km-empty__title"
    >
      <slot name="title">
        {{ title }}
      </slot>
    </div>
    <slot>
      {{ desc }}
    </slot>
  </div>
</template>

<script>
export default {
  name: 'KEmpty',
  props: {
    image: {
      type: String,
      default: null,
    },
    title: {
      type: String,
      default: '',
    },
    desc: {
      type: String,
      default: '',
    },
    // large / small
    size: {
      validator: (value) => ['large', 'small'].indexOf(value) > -1,
      type: String,
      default: null,
    },
    delay: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      imageDefault: 'https://rd5-public.zhaopin.cn/imgs/empty-box.png',
      imageDefaultRetina: 'https://rd5-public.zhaopin.cn/imgs/empty-box@2x.png',
      shouldShow: true,
    }
  },
  computed: {
    hasTitle() {
      return this.$slots.title || this.title
    },
    css() {
      return {
        'km-empty--large': this.size === 'large',
        'km-empty--small': this.size === 'small',
      }
    },
    imgCss() {
      return {
        'km-empty__img--default': !this.image,
      }
    },
  },
  created() {
    if (this.delay) {
      this.shouldShow = false
      setTimeout(() => {
        this.shouldShow = true
      }, this.delay)
    }
  },
}
</script>
